import CommonContent from './Common';

class SummaryContents extends CommonContent {
  constructor() {
    super();
    this.summaryCols =
      TMON.util.getHashJSON().col ||
      this.dealSummaryInfo.summaryContents.summaryCols ||
      'column1';
    this.welWrapper = $("#_wrapDealContents");
  }

  get dealSummaryInfo() {
    return this.htDealContentInfo.dealSummaryInfo || {};
  }

  get viewPrice() {
    return this.dealSummaryInfo.summaryContents.viewPrice;
  }

  initHTML() {
    this.initData();
    let html = '';
    html += this.makeVideoContent();
    html += this.makeIntro();
    html += this.makeOptionDetailLook();
    html += this.bOptionDeal
      ? `<div class="btn_deal_wrap">${this.makeAllButton()}</div>`
      : "";
    return html;
  }

  updateHTML() {
    this.summaryContents = this.filteringSummaryContents();
    /* 자세히보기 옵션목록 - SUMMARY 타입 */
    if (this.summaryContents.length > 0 && !this.bOptionDeal) {
      const sHtml = `<div class="tmde-template-wrapper review_opt
      ${
        this.bShowAdditionalButton ? "button_show" : ""
      } r4 _summaryOptionList">
        <div class="tmde-template loaded ${
          this.summaryCols
        }">${this.summaryContents
        .map((item, idx) => this.getSummaryOptionItemHtml(item, idx))
        .join("")}
        </div>
      </div>`;
      this.welWrapper.append(sHtml);
    } 
    /* 자세히보기 상세이미지 - SUMMARY 타입 / 단일 */
    else if (this.summaryContents.length > 0 && this.bOptionDeal) {
      const sHTML = `<div class="tmde-review review_opt r7">
            <div class="inr"></div>
        </div>`;
      this.initReviewOpt(".review_opt.r7 .inr", sHTML);
      const updateSummaryContents =
        this.summaryContents[this.nOptionDealIndex];
        this.updateSingleSummary(updateSummaryContents);
      const updateHtml = this.getSummaryDetailItemHtml(
        updateSummaryContents,
        this.nOptionDealIndex,
        true
      );
      this.welWrapper.find(".review_opt.r7 .inr").html(updateHtml);
    }
    // '특정옵션에만 할인이 적용되어 있습니다.' 문구 추가
    this.showBannerDiscountOnSpecificOption(
      this.contentType,
      this.summaryContents
    );
    // 옵션 이미지 렌더링 후 여행 체크리스트 렌더링
    const sHtml = this.makeTravelCheckList();
    this.welWrapper.append(sHtml);
  }

  updateDetailImageHTML(nDetailImageSplitIdx) {
    const nDetailImageStartIdx = nDetailImageSplitIdx - 50;
    let sHtml = '';
    if (
      /* 전체 딜 */
      !this.bOptionDeal &&
      TMON.htStaticData.htDetailABTestInfo.bShowReviewContents &&
      this.summaryContents.length > 0
    ) {
      // const nDetailImageStartIdx = nDetailImageSplitIdx - 50;
      sHtml = this.makeDetailImage(this.summaryContents.slice(nDetailImageStartIdx, nDetailImageSplitIdx), nDetailImageStartIdx);
    }
    this.welWrapper.append(sHtml);
  }

  initData() {
    this.colsSetting();
  }

  filteringSummaryContents() {
    const contentList =
      (TMON.oApp.getStorage('splitContent') &&
        TMON.oApp.getStorage('splitContent').data.dealSummaryInfo
          .contentList) ||
      [];
    return contentList.filter(item => item.summaryContent);
  }

  /*
   * 인트로 이미지 - SUMMARY 타입
   * SUMMARY TYPE introContents가 있을경우 intro영역을 노출
   */
  makeIntro() {
    const { introContents = [] } = this.dealSummaryInfo; // 인트로 이미지 - SUMMARY 타입 data
    return introContents.length > 0
      ? `<div class="r1 tmde-template-wrapper">${introContents
          .map(item => this.getLazyImgHtml(item, true))
          .join('')}</div>`
      : '';
  }


  makeDetailImage(filteredSummaryContents, summaryStartIdx) {
    return `
      <div class="tmde-review review_opt r8">
          <div class="inr">${filteredSummaryContents
            .map((item, idx) => this.getSummaryDetailItemHtml(item, summaryStartIdx + idx, true))
            .join('')}</div>
      </div>`;
  }

  /* Summary 단일 옵션 Update */
  updateSingleSummary(updateSummaryContents) {
    if (updateSummaryContents) {
      const sHTML = `<div class="tmde-review review_opt r7">
                <div class="inr"></div>
            </div>`;
      this.initReviewOpt('.review_opt.r7 .inr', sHTML);
      const updateHtml = this.getSummaryDetailItemHtml(
        updateSummaryContents,
        this.nOptionDealIndex,
        true
      );
      this.welWrapper.find('.review_opt.r7 .inr').html(updateHtml);
    }
  }

  /* Summary 전체 옵션 Update */
  updateAllSummary(updateSummaryContents, contentsLimit) {
    const sHtml = updateSummaryContents.map((item, idx) =>
      this.getSummaryOptionItemHtml(item, idx + contentsLimit)
    );
    this.welWrapper.find('._summaryOptionList .tmde-template').append(sHtml);
  }

  /**
   * 자세히보기 상세이미지 - SUMMARY 타입
   */
  getSummaryDetailItemHtml(item, idx, bShow) {
    if (!Object.keys(item).length) {
      return null;
    }

    const reviewHtml = item.reviewContent
      ? item.reviewContent
          .replace(/\\n/g, '')
          .replace(/\\t/g, '')
          .replace(/\\r/g, '')
          .replace(/\\/g, '')
          .replace(/^"/, '')
          .replace(/"$/, '')
          .replace(
            /<div class="tmde-component-option">/g,
            '<div class="tmde-component-option" style="display: none">'
          )
          .replaceAll('http://', 'https://')
      : '';
    // [FR-3190] 할인가가 두번 적용될 때(정율할인 이후 즉시할인)가 있어 정률 할인 여부를 priceType 뿐만 아니라 dcRt도 고려 해야 함
    const bPriceTypeRate = item.priceType === 'RATE' || item.dcRt > 0;

    let nDicountPrice = item.price;

    if (item.priceType === 'SALE') {
      // dcPrc = 티몬가
      nDicountPrice = item.dcRt > 0 ? item.dcPrc : item.originalPrice;
    }
    let viewPrice = 'Y';
    try {
      viewPrice = this.viewPrice;
    } catch (e) {
      // console.log(e);
    }

    return `<div class="tmde-review-template contents-options" data-idx="${idx}" ${
      !bShow ? 'style="display:none"' : ''
    }>
                <div class="tmde-opt-info">
                    <strong class="tmde-opt-label">${idx + 1}</strong>
                    <cite class="tmde-opt-subject">
                      ${item.isBundleOnly ? '<strong class="addoption">[추가구매상품]</strong>' : ''}
                      ${item.optionTitle.split('|')[0]}
                    </cite>
                </div>
                ${
                  viewPrice === 'Y'
                    ? `
                    <div style="text-align:center">
                        <div class="tmde-spot-discount ${
                          bPriceTypeRate ? 'tmde-spot-per' : 'tmde-spot-tmon'
                        }">
                            ${
                              bPriceTypeRate
                                ? `<span class="tmde-spot"><span class="tmde-figure">${item.dcRt}</span>%</span>`
                                : `<span class="tmde-spot">${TMON.oApp.htStorage.priceTypeText}</span>`
                            }
                            <span class="tmde-spot-price">
                                ${
                                  bPriceTypeRate
                                    ? `<span class="tmde-add-spot">
                                            <span class="line" />
                                            <em class="tmde-figure">${TMON.util.numberFormat(
                                              item.originalPrice
                                            )}</em>원
                                        </span>`
                                    : ''
                                }
                                <em class="tmde-add-spot-price">
                                    <em class="tmde-figure">${TMON.util.numberFormat(
                                      nDicountPrice
                                    )}</em>원
                                </em>
                            </span>
                        </div>
                        ${
                          item.priceType === 'SALE'
                            ? `<div class="tmde-spo-discout-wrap">
                                    <span class="tmde-spot-discount">
                                        <span class="tmde-spot">즉시할인가</span>
                                        <span class="tmde-spot-price"><em class="tmde-figure">${TMON.util.numberFormat(
                                          item.price
                                        )}</em>원</span>
                                    </span>
                                </div>`
                            : ''
                        }
                    </div>
                `
                    : ''
                }
                ${
                  reviewHtml
                    ? TMON.oApp.oUtil.getLazyInnerHtml(reviewHtml, 'unload')
                    : '<div class="no-image a"><div class="no-image-inner"><i></i></div></div>'
                }
            </div>`;
  }

  /**
   * 딜써머리 자동화 딜이고 옵션딜에 즉시할인이 설정되어있으면 '특정 옵션에만 할인이 적용되어 있습니다.'를 노출한다.
   * @param {*} sContentType
   * @param {*} aContentList
   */
  showBannerDiscountOnSpecificOption(sContentType, aContentList) {
    if (
      sContentType !== 'SUMMARY' ||
      $('#_bannerDiscountOnOption').length >= 1
    ) {
      // 딜써머리 자동화 딜인가?, 이미 베너가 추가되었는가
      return;
    }

    let bFoundSaleOption = false; // 옵션중에 priceType이 SALE이 하나라도 있는 경우 즉시 할인이 설정되어 있는 경우이다.
    for (let i = 0; i < aContentList.length; i += 1) {
      if (aContentList[i].priceType === 'SALE') {
        // priceType 이 'SALE'일 경우 즉시할인이다.
        bFoundSaleOption = true;
        break;
      }
    }

    // 옵션리스트 바로 위에 추가해준다.
    if (bFoundSaleOption) {
      $(`<div class="sub-guide" id="_bannerDiscountOnOption">
                <i class="sub-guide-ico"></i>
                <p class="sub-guide-text"><span class="sub-guide-color">특정 옵션에만 할인이 적용</span>되어 있습니다.</p>
            </div>`).insertBefore(this.welWrapper.find('._summaryOptionList'));
    }
  }

  colsSetting() {
    // 모바일일 경우 최대값이 column2
    if (TMON.oApp.sPlatform !== 'PW' && this.summaryCols === 'column3') {
      this.summaryCols = 'column2';
    }
    // this.nCols 정의
    if (this.summaryCols === 'column2') {
      this.nCols = 2;
    } else if (this.summaryCols === 'column3') {
      this.nCols = 3;
    }
  }

  /**
   * 자세히보기 옵션 목록의 옵션 - SUMMARY 타입
   */
  getSummaryOptionItemHtml(item, idx) {
    if (!Object.keys(item).length) {
      return null;
    }
    const optionTitleRegex = /(^[0-9]+)(\.)/gim;
    const optionTitle = item.optionTitle
      .split('|')[0]
      .replace(optionTitleRegex, '');

    // [FR-3190] 할인가가 두번 적용될 때(정율할인 이후 즉시할인)가 있어 정률 할인 여부를 priceType 뿐만 아니라 dcRt도 고려 해야 함
    const bPriceTypeRate = item.priceType === 'RATE' || item.dcRt > 0;

    let nDicountPrice = item.price;

    if (item.priceType === 'SALE') {
      // dcPrc = 티몬가
      nDicountPrice = item.dcRt > 0 ? item.dcPrc : item.originalPrice;
    }
    this.nRows = Math.floor(idx / this.nCols) + 1;
    const summary = JSON.parse(item.summaryContent || {});
    return `<div class="tmde-template-colmn" data-insert="image" data-row="${
      this.nRows
    }" data-role="op">
                <a href="#scene=scene-optiondetail&order_no=${idx}" data-order="${idx}" data-role="openOptionDeal" data-tlarea="${
      this.tlCode.area.openOptionDeal
    }" data-tlord="1" class="optiondetail_clickable">
                    <span class="tmde-opt-thmb">
                        ${
                          item.isSoldOut === 'Y'
                            ? '<div class="sold_out"><span class="txt_sold" /></div>'
                            : ''
                        }
                        ${
                          summary.thmb
                            ? this.getLazyImgHtml(summary.thmb, true)
                            : ''
                        }
                    </span>
                    <span class="tmde-opt-info">
                        <em class="tmde-opt-label">${idx + 1}</em>
                        <cite class="tmde-opt-subject" data-type="s">
                          ${item.isBundleOnly ? '<strong class="addoption">[추가구매상품]</strong>' : ''}
                          ${optionTitle}
                        </cite>
                        ${
                          summary.detail
                            ? `<p class="tmde-opt-detail" data-type="d">${
                                TMON.oApp.oUtil.getLazyInnerHtml(
                                  summary.detail,
                                  'unload'
                                )}</p>`
                            : ''
                        }
                        <span class="tmde-opt-price">
                            <div>
                                <span class="tmde-price-optional">
                                    ${
                                      bPriceTypeRate
                                        ? `<span class="tmde-discount-per"><span class="tmde-figure">${item.dcRt}</span>%</span>`
                                        : `<span class="tmde-tmon-price">${TMON.oApp.htStorage.priceTypeText}</span>`
                                    }
                                    <span class="tmde-condition">
                                        ${
                                          bPriceTypeRate
                                            ? `<span class="tmde-origin-price">
                                                    <span class="tmde-figure">${TMON.util.numberFormat(
                                                      item.originalPrice
                                                    )}</span>원<span class="line" />
                                                </span>`
                                            : ''
                                        }
                                        <span class="tmde-discount-price">
                                            <span class="tmde-figure">${TMON.util.numberFormat(
                                              nDicountPrice
                                            )}</span>원
                                        </span>
                                    </span>
                                </span>
                                ${
                                  item.priceType === 'SALE'
                                    ? `<div class="tmde-spo-discout-wrap">
                                            <div class="tmde-spo-discout-wrap">
                                                <span class="tmde-spot-discount">
                                                    <span class="tmde-spot">즉시할인가</span>
                                                    <span class="tmde-spot-price">
                                                        <em class="tmde-figure">${TMON.util.numberFormat(
                                                          item.price
                                                        )}</em>원
                                                    </span>
                                                </span>
                                            </div>
                                        </div>`
                                    : ''
                                }
                            </div>
                        </span>
                    </span>
                </a>
                ${
                  this.bShowAdditionalButton
                    ? `
                    <div class="item_button">
                        <a href="#scene=scene-optiondetail&order_no=${idx}" class="item_button_view" data-tlarea="TESTDDO" data-tlord="1" data-role="openOptionDeal" data-order="${idx}">상세보기</a>
                        <button class="item_button_option" type="button" data-tlarea="TESTDDO" data-tlord="2" data-role="옵션선택"><i></i>옵션선택</button>
                    </div>
                `
                    : ''
                }
            </div>`;
  }
}

export default SummaryContents;
